import { DEFAULT_PRINT_FILE_JOBS_PARAMS } from './defaults';

const reducers = {
    clearPrintFileJobsFilters: (state: any) => {
        state.queryParams = { ...DEFAULT_PRINT_FILE_JOBS_PARAMS() };
    },
    setPrintFileJobsQueryParams: (state: any, action: any) => {
        state.queryParams = { ...state.queryParams, ...action.payload };
    },
};

export default reducers;
